// URL parsers load with the route tree; keep their values independent of page code.
export const ADMIN_SECTIONS = ["people", "quality", "payroll"] as const;
export type AdminSection = (typeof ADMIN_SECTIONS)[number];
export interface AdminUrlState {
  readonly month?: string;
  readonly section?: AdminSection;
}
